import routeName from '../constant';

const routes = [
    {
        path: 'delay-payment',
        name: routeName.DELAY_PAYMENT,
        component: () => import('@/views/aplCatl640and631/A2/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '保費緩繳', leaveAlert: true, code: 'A2', unableBack: true },
    },
];

export default routes;
